import { render, staticRenderFns } from "./feedbackSvg.vue?vue&type=template&id=23deafa2"
import script from "./feedbackSvg.vue?vue&type=script&lang=js"
export * from "./feedbackSvg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports